"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInKindAllowed = exports.isInKindValueHiddenFromDonor = exports.isInKindValueOptional = void 0;
const payment_1 = require("../../enums/payment");
const country_1 = require("../enums/country");
const isInKindValueOptional = (country) => {
    return country === country_1.OrganizationCountry.UnitedStates;
};
exports.isInKindValueOptional = isInKindValueOptional;
const isInKindValueHiddenFromDonor = ({ country, paymentMethod, }) => {
    return paymentMethod === payment_1.PaymentMethod.InKind && (0, exports.isInKindValueOptional)(country);
};
exports.isInKindValueHiddenFromDonor = isInKindValueHiddenFromDonor;
const isInKindAllowed = (country) => {
    return country !== country_1.OrganizationCountry.Australia && country !== country_1.OrganizationCountry.Germany;
};
exports.isInKindAllowed = isInKindAllowed;
